module.exports = __webpack_public_path__ + "static/media/home_work.3170ef70.svg";